import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('pricing');

export class Details extends Api {
  constructor(http, config = {}) {
    super(http, url, 'details-by-filter', config);
  }
}